import { __assign, __read, __rest } from "tslib";
import React, { useState, useRef } from 'react';
import { useOnClickOutside } from '@marvelapp/hooks';
import { BackButton, Badge, Box, Flex, Heading, PinTL, Popover, Text, ToolbarButton, UserTag, } from '@marvelapp/ui';
import { ExternalLinkIcon } from './icons';
import SidebarMenuItem from './SidebarMenuItem';
import SidebarQRCode from './SidebarQRCode';
export default function SidebarMenu(_a) {
    var projectModified = _a.projectModified, projectName = _a.projectName, projectOwner = _a.projectOwner, projectsByOwnerUrl = _a.projectsByOwnerUrl, projectUrl = _a.projectUrl, screenCount = _a.screenCount, screenName = _a.screenName, screenNumber = _a.screenNumber, screenUrl = _a.screenUrl, showScanQR = _a.showScanQR, onShowGrid = _a.onShowGrid, onShowHome = _a.onShowHome, userFlowsUrl = _a.userFlowsUrl;
    var selectedRoleDropdown = useRef(null);
    var _b = __read(useState(false), 2), isPopoverOpen = _b[0], setIsPopoverOpen = _b[1];
    var _c = __read(useState(false), 2), isQRCodeOpen = _c[0], setIsQRCodeOpen = _c[1];
    useOnClickOutside(selectedRoleDropdown, function () {
        setIsPopoverOpen(false);
    });
    var togglePopover = function () {
        setIsPopoverOpen(function (isOpen) { return !isOpen; });
        setIsQRCodeOpen(false);
    };
    var toggleQRCode = function () {
        setIsQRCodeOpen(function (isOpen) { return !isOpen; });
    };
    return (React.createElement("div", { ref: selectedRoleDropdown },
        React.createElement(ToolbarButton, { isActive: isPopoverOpen, onClick: togglePopover }, "Menu"),
        React.createElement(Popover, { align: "left", isActive: isPopoverOpen, showOn: "custom", width: 260 },
            React.createElement(Box, { maxWidth: 260, overflow: "hidden", position: "relative" },
                React.createElement(Box, { opacity: isQRCodeOpen ? 0 : 1, transform: isQRCodeOpen ? 'translateX(-100%)' : 'translateX(0)', transition: "smooth.fast" },
                    React.createElement(Header, null,
                        React.createElement("div", null,
                            React.createElement(Heading, { "data-testid": "menu-project-name", fontSize: 3, lineHeight: 1.4, marginBottom: 1 }, projectName),
                            React.createElement(Text, { fontSize: 2 }, screenName)),
                        React.createElement("div", null,
                            React.createElement(Badge, { kind: "ghost" },
                                screenNumber,
                                " / ",
                                screenCount))),
                    projectOwner && projectModified && (React.createElement(Header, null,
                        React.createElement("div", null,
                            React.createElement(Text, { "data-testid": "menu-project-author", fontSize: 2, marginTop: 1 },
                                "by",
                                ' ',
                                projectsByOwnerUrl ? (React.createElement(UserTag, { as: "a", "data-testid": "menu-project-owner-link", href: projectsByOwnerUrl }, projectOwner)) : (projectOwner)),
                            React.createElement(Text, { "data-testid": "menu-project-modified-date", fontSize: 2, marginTop: 1 },
                                "Modified ",
                                projectModified,
                                " ago")))),
                    React.createElement(Box, { py: 2 },
                        React.createElement(SidebarMenuItem, { "data-testid": "menu-home", keyboardShortcut: "H", onClick: onShowHome }, "Go to the start"),
                        React.createElement(SidebarMenuItem, { "data-testid": "menu-grid", keyboardShortcut: "G", onClick: onShowGrid }, "View all screens"),
                        showScanQR && (React.createElement(SidebarMenuItem, { "data-testid": "menu-toggle-qr", onClick: toggleQRCode }, "Scan QR code")),
                        projectUrl && (React.createElement(SidebarMenuLink, { "data-testid": "menu-open-project", href: projectUrl }, "Open project")),
                        screenUrl && (React.createElement(SidebarMenuLink, { "data-testid": "menu-edit-screen", href: screenUrl }, "Edit screen")),
                        userFlowsUrl && (React.createElement(SidebarMenuLink, { "data-testid": "menu-view-userflows", href: userFlowsUrl }, "View Userflows")))),
                React.createElement(Box, { alignItems: "center", bg: "white", borderRadius: 2, display: "flex", flexDirection: "column", height: "100%", justifyContent: "center", left: 0, opacity: isQRCodeOpen ? 1 : 0, position: "absolute", top: 0, transform: isQRCodeOpen ? 'translateX(0)' : 'translateX(100%)', transition: "smooth.fast", width: "100%" },
                    React.createElement(PinTL, { onClick: toggleQRCode, padding: 3 },
                        React.createElement(BackButton, { height: 30, width: 30 })),
                    isQRCodeOpen && React.createElement(SidebarQRCode, null))))));
}
function SidebarMenuLink(_a) {
    var children = _a.children, dataTestId = _a["data-testid"], props = __rest(_a, ["children", 'data-testid']);
    return (React.createElement(SidebarMenuItem, __assign({}, props),
        React.createElement("div", null,
            children,
            " ",
            React.createElement(ExternalLinkIcon, { overflow: "visible !important" }))));
}
function Header(_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Flex, __assign({ alignItems: "center", borderBottom: "1px solid", borderColor: "smoke", justifyContent: "space-between", padding: 3 }, props), children));
}
